import React from 'react';
import PropTypes from 'prop-types';
import Table from 'cccisd-table';
import { round, mean } from 'lodash';

const SubscaleTable = props => {
    const { data, subscales } = props;

    const getData = d => {
        const rows = [];
        const ccmap = {};

        for (const subscale of subscales) {
            const subscaleCcScores = {};

            for (const item of subscale.items) {
                for (const cc of d.flows[item].frequency) {
                    if (cc.value) {
                        if (!ccmap[cc.value]) {
                            ccmap[cc.value] = {};
                        }

                        if (!subscaleCcScores[cc.value]) {
                            subscaleCcScores[cc.value] = [];
                        }

                        if (cc.avg !== null) {
                            subscaleCcScores[cc.value].push(cc.avg);
                        }
                    }
                }
            }

            for (const cc of Object.keys(subscaleCcScores)) {
                if (subscaleCcScores[cc].length === 0) {
                    continue;
                }

                ccmap[cc][subscale.name] = mean(subscaleCcScores[cc]) * 100;
            }
        }

        for (const cc of Object.keys(ccmap)) {
            const row = {
                cc,
                careCoord: cc.split(', ')[0],
            };

            for (const subscale of subscales) {
                row[subscale.name] = typeof ccmap[cc][subscale.name] === 'number' ? ccmap[cc][subscale.name] : null;
            }

            rows.push(row);
        }

        return rows;
    };

    const getTotal = td => {
        let total = { careCoord: 'Total: ', cc: 'totalRow' };
        for (const key of Object.keys(td[0])) {
            if (!['careCoord', 'cc'].includes(key)) {
                const keyTotal = [];
                let allNull = true;
                for (const row of td) {
                    if (row[key] !== null) {
                        allNull = false;
                        keyTotal.push(row[key]);
                    }
                }
                if (allNull) {
                    total[key] = '';
                } else {
                    total[key] = `${round(mean(keyTotal), 2)}%`;
                }
            }
        }
        return total;
    };

    const cols = [
        {
            name: 'careCoord',
            label: 'Care Coordinator',
            sort: true,
            filter: true,
        },
        ...subscales.map(s => ({
            name: s.name,
            label: s.label,
            sort: true,
            render: (value, row) => (value !== null ? `${round(value, 2)}%` : 'N/A*'),
        })),
    ];

    const tableData = getData(data);
    const totalRow = getTotal(tableData);

    let showNotice = false;
    for (const row of tableData) {
        if (!showNotice) {
            if (Object.keys(row).some(key => row[key] === null)) {
                showNotice = true;
            }
        }
    }

    return (
        <>
            <Table
                data={tableData}
                rowKey="cc"
                orderBy="careCoord"
                columns={cols}
                footer={totalRow}
                showPerPageOptions={false}
                isCsvDownload
            />
            {showNotice && (
                <p>
                    *All TOMs for this item were scored as &quot;N/A&quot;, thus a summary score can not be calculated
                </p>
            )}
        </>
    );
};

SubscaleTable.propTypes = {
    data: PropTypes.object,
    subscales: PropTypes.array,
};

export default SubscaleTable;
